import React from "react";

/**
 * Minimal markdown-lite renderer for public job postings.
 * Supports "## Section", "### Subsection", "- bullet" lists, and plain paragraphs.
 * Deliberately tiny (no external markdown lib) since job postings only ever use these constructs.
 */
export const SimpleMarkdown = ({ text, testId }) => {
  if (!text) return null;
  const lines = text.split("\n");
  const blocks = [];
  let listBuffer = [];

  const flushList = () => {
    if (listBuffer.length) {
      blocks.push({ type: "ul", items: listBuffer });
      listBuffer = [];
    }
  };

  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { flushList(); continue; }
    if (line.startsWith("### ")) { flushList(); blocks.push({ type: "h3", text: line.slice(4) }); }
    else if (line.startsWith("## ")) { flushList(); blocks.push({ type: "h2", text: line.slice(3) }); }
    else if (line.startsWith("- ")) { listBuffer.push(line.slice(2)); }
    else { flushList(); blocks.push({ type: "p", text: line }); }
  }
  flushList();

  return (
    <div data-testid={testId} className="space-y-3">
      {blocks.map((b, idx) => {
        if (b.type === "h2") return <h2 key={idx} className="text-lg sm:text-xl font-bold text-blue-950 border-b border-amber-300 pb-1.5 pt-4 first:pt-0">{b.text}</h2>;
        if (b.type === "h3") return <h3 key={idx} className="text-sm font-bold uppercase tracking-wide text-amber-600">{b.text}</h3>;
        if (b.type === "ul") return (
          <ul key={idx} className="space-y-1.5 list-disc list-outside pl-5">
            {b.items.map((item, i) => <li key={i} className="text-sm sm:text-base text-gray-600 leading-relaxed break-words">{item}</li>)}
          </ul>
        );
        return <p key={idx} className="text-sm sm:text-base text-gray-600 leading-relaxed break-words">{b.text}</p>;
      })}
    </div>
  );
};
